export default __webpack_public_path__ + "static/media/pantry1-afterF-480w.244e5439.avif";